import React, { Component } from "react";
import { JobPackWrapper } from "../../../wrappers";
import blankProfile from "./blankProfile";
import colors from "./colors.json";
import SecurityModal from "../Components/SecurityModal/SecurityModal";
import { connect } from "react-redux";
import {
    selectPermission,
    selectAreas,
    selectDepartments,
    selectMapKey,
    selectReportPermission,
} from "./selectors";
import {
    setPageType,
    getPermissions,
    getProfile,
    getAreas,
    getDepartments,
} from "./actions";
import {
    JobPackProfileInfoWidget,
    JobPackProfileAddressWidget,
    JobPackAssignessArrayListWidget,
    JobPackGeneralFilesWidget,
    JobPackMethodStatementWidget,
    JobPackProfileRelatedReportsWidget,
    JobPackEquipmentListWidget,
    JobPackVehicleListWidget,
    JobPackSelectReports,
    JobPackProfileAttachedPhotosWidget,
    JobPackTrainingRulesWidget,
    JobPackToolboxTalkWidget,
} from "../../../widgets";
import { Grid } from "@material-ui/core";
const reducer = "JobPackV3_reducer";

const JobPackWrapper_selectors = JobPackWrapper.createSelectors(reducer);
const JobPackAssigneesArrayList_selectors = JobPackAssignessArrayListWidget.createSelectors(
    reducer
);
const JobPackToolboxTalkWidget_selectors = JobPackToolboxTalkWidget.createSelectors(
    reducer
);
const JobPackTrainingRulesWidget_selectors = JobPackTrainingRulesWidget.createSelectors(
    reducer
);
const JobPackVehicleList_selectors = JobPackVehicleListWidget.createSelectors(
    reducer
);
const JobPackEquipmentList_selectors = JobPackEquipmentListWidget.createSelectors(
    reducer
);
const JobPackMethodStatement_selectors = JobPackMethodStatementWidget.createSelectors(
    reducer
);
const relatedReportsSelector = JobPackProfileRelatedReportsWidget.createSelectors(
    reducer
);

const JobPackSelectReports_selectors = JobPackSelectReports.createSelectors(
    reducer
);

export const JOB_PACK_GENERAL_FILES_REDUCER =
    "JobPackGeneralFilesWidget_reducer";
export const JOB_PACK_GENERAL_FILES_TYPES = "JOB_PACK_GENERAL_FILES";

const JobPackGeneralFiles_selectors = JobPackGeneralFilesWidget.createSelectors(
    reducer,
    JOB_PACK_GENERAL_FILES_REDUCER
);
const JobPackGeneralFiles_actions = JobPackGeneralFilesWidget.createActions(
    JobPackGeneralFilesWidget.createTypes(JOB_PACK_GENERAL_FILES_TYPES)
);

class JobPackV3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jobType: "jobpack",
            rules: [],
        };
        props.setPageType(props.match.params.type);
        props.getPermissions();
        props.getProfile();
        props.getDepartments();
        props.getAreas();
    }
    render() {
        if (this.props.permission)
            return (
                <JobPackWrapper.view
                    match={this.props.match}
                    history={this.props.history}
                    setJobPackType={(jobType) => {
                        this.setState({ jobType: jobType });
                    }}
                    setRules={(rules) => {
                        this.setState({ rules });
                    }}
                    rules={this.state.rules}
                    selectors={JobPackWrapper_selectors}
                    blankProfile={blankProfile}
                    colors={colors}
                >
                    {(profile, edit, setState) => {
                        return (
                            <>
                                <Grid item xs={6} xl={6}>
                                    <JobPackProfileInfoWidget.view
                                        profile={profile}
                                        areas={this.props.areas}
                                        departments={this.props.departments}
                                        edit={edit}
                                        jobType={this.state.jobType}
                                        callback={(key, value) => {
                                            setState(key, value);
                                        }}
                                    />
                                </Grid>
                                {this.state.jobType === "jobpack" && (
                                    <Grid item xs={6} xl={6}>
                                        <JobPackProfileAddressWidget.view
                                            profile={profile}
                                            edit={edit}
                                            callback={(key, value) => {
                                                setState(key, value.toString());
                                            }}
                                        />
                                        <br />
                                        <JobPackAssignessArrayListWidget.view
                                            profile={profile}
                                            edit={edit}
                                            callback={(key, value) => {
                                                setState(key, value);
                                            }}
                                            selectors={
                                                JobPackAssigneesArrayList_selectors
                                            }
                                        />
                                    </Grid>
                                )}
                                {this.state.jobType === "jobpack" && (
                                    <Grid item xs={6} xl={6}>
                                        <JobPackVehicleListWidget.view
                                            profile={profile}
                                            edit={edit}
                                            new={
                                                this.props.match.type ===
                                                "create"
                                            }
                                            callback={(key, value) => {
                                                setState(key, value);
                                            }}
                                            selectors={
                                                JobPackVehicleList_selectors
                                            }
                                        />
                                    </Grid>
                                )}
                                {this.state.jobType === "jobpack" && (
                                    <Grid item xs={6} xl={6}>
                                        <JobPackToolboxTalkWidget.view
                                            profile={profile}
                                            edit={edit}
                                            new={
                                                this.props.match.type ===
                                                "create"
                                            }
                                            callback={(key, value) => {
                                                setState(key, value);
                                            }}
                                            selectors={
                                                JobPackToolboxTalkWidget_selectors
                                            }
                                        />
                                    </Grid>
                                )}
                                {this.state.jobType === "jobpack" && (
                                    <Grid item xs={6} xl={6}>
                                        <JobPackEquipmentListWidget.view
                                            profile={profile}
                                            edit={edit}
                                            new={
                                                this.props.match.type ===
                                                "create"
                                            }
                                            callback={(key, value) => {
                                                setState(key, value);
                                            }}
                                            selectors={
                                                JobPackEquipmentList_selectors
                                            }
                                        />
                                    </Grid>
                                )}
                                {this.state.jobType === "template" && (
                                    <Grid item xs={6} xl={6}>
                                        <JobPackTrainingRulesWidget.view
                                            profile={profile}
                                            edit={edit}
                                            callback={(key, value) => {
                                                setState(key, value);
                                            }}
                                            rules={this.state.rules}
                                            setRules={(rules) => {
                                                this.setState({ rules });
                                            }}
                                            selectors={
                                                JobPackTrainingRulesWidget_selectors
                                            }
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={6} xl={6}>
                                    <JobPackGeneralFilesWidget.view
                                        profile={profile}
                                        edit={edit}
                                        callback={(key, value) => {
                                            setState(key, value);
                                        }}
                                        selectors={
                                            JobPackGeneralFiles_selectors
                                        }
                                        actions={JobPackGeneralFiles_actions}
                                        title="General Jobpack Files"
                                        // file_type="job_pack_files"
                                        st={this.props.match.params.status}
                                        year={this.props.match.params.year}
                                        month={this.props.match.params.month}
                                    />
                                </Grid>
                                <Grid item xs={6} xl={6}>
                                    <JobPackMethodStatementWidget.view
                                        profile={profile}
                                        edit={edit}
                                        callback={(key, value) => {
                                            setState(key, value);
                                        }}
                                        selectors={
                                            JobPackMethodStatement_selectors
                                        }
                                        st={this.props.match.params.status}
                                        year={this.props.match.params.year}
                                        month={this.props.match.params.month}
                                    />
                                </Grid>

                                <Grid item xs={12} xl={12}>
                                    <JobPackSelectReports.view
                                        profile={profile}
                                        edit={edit}
                                        callback={(key, value) => {
                                            setState(key, value);
                                        }}
                                        selectors={
                                            JobPackSelectReports_selectors
                                        }
                                    />
                                </Grid>

                                {this.props.match.params.type === "view" && (
                                    <Grid item xs={12} xl={12}>
                                        <JobPackProfileRelatedReportsWidget.view
                                            selectors={relatedReportsSelector}
                                            uid={this.props.match.params.uid}
                                            st={this.props.match.params.status}
                                            year={this.props.match.params.year}
                                            month={
                                                this.props.match.params.month
                                            }
                                            reportPermissions={
                                                this.props.reportPermissions
                                            }
                                        />
                                    </Grid>
                                )}
                                {this.props.match.params.type === "view" && (
                                    <Grid item xs={12} xl={12}>
                                        <JobPackProfileAttachedPhotosWidget.view
                                            profile={profile}
                                            edit={edit}
                                        />
                                    </Grid>
                                )}
                            </>
                        );
                    }}
                </JobPackWrapper.view>
            );
        else
            return (
                <SecurityModal
                    errType={this.props.match.params.type}
                    errPage={"Jobpack"}
                    history={this.props.history}
                />
            );
    }
}

export default connect(
    (store) => {
        return {
            permission: selectPermission(store),
            areas: selectAreas(store),
            departments: selectDepartments(store),
            mapKey: selectMapKey(store),
            reportPermissions: selectReportPermission(store),
        };
    },
    { setPageType, getPermissions, getProfile, getAreas, getDepartments }
)(JobPackV3);
